import axios from '@axios'
export const state = {
  routeGroups: [],
  perPage: 15,
  totalPages: 1,
  currentPage: 1,
  totalRecords: 1,
}

export const getters = {
  allRouteGroups: (state) => state.routeGroups,
  currentPage: (state) => state.currentPage,
  totalPages: (state) => state.totalPages,
  perPage: (state) => state.perPage,
  totalRecords: (state) => state.totalRecords,
}

export const mutations = {
  GET_ROUTE_GROUPS: (state, data) => {
    state.routeGroups = data.routeGroups
    state.currentPage = data.page
    state.totalPages = data.totalPages
    state.perPage = data.perPage
    state.totalRecords = data.totalRecords
  },
  CREATE_ROUTE_GROUP: (state, routeGroup) => {
    state.routeGroups.unshift(routeGroup)
  },
  UPDATE_ROUTE_GROUP: (state, routeGroup) => {
    state.routeGroups = state.routeGroups.filter(
      (rg) => rg.id !== routeGroup.id
    )
    state.routeGroups.unshift(routeGroup)
  },
  REMOVE_ROUTE_GROUP: (state, routeGroup) => {
    state.routeGroups = state.routeGroups.filter(
      (rg) => rg.id !== routeGroup.id
    )
  },
  DEFAULT_ROUTE_GROUP: (state, data) => {
    state.routeGroups.forEach((element) => {
      if (element.id === data.id) {
        element.default = data.default
      } else if (element.default === data.default) {
        element.default = null
      }
    })
  },
}

export const actions = {
  async getRouteGroups({ commit }, params = {}) {
    let { _commit } = params
    if (typeof _commit === 'boolean' && _commit === false)
      return axios.get('/sms/route-groups', { params: params })
    await axios.get('/sms/route-groups', { params: params }).then((resp) => {
      if (resp.status === 200) {
        commit('GET_ROUTE_GROUPS', resp.data)
      }
    })
  },
  async getRouteGroup({ commit }, routeGroup) {
    return axios.get(`/sms/route-groups/${routeGroup.id}`, routeGroup)
  },
  async createRouteGroup({ commit }, routeGroup) {
    await axios.post('/sms/route-groups', routeGroup).then((resp) => {
      if (resp.status === 201) {
        commit('CREATE_ROUTE_GROUP', resp.data)
      }
    })
  },
  async updateRouteGroup({ commit }, routeGroup) {
    await axios.put(`/sms/route-groups`, routeGroup).then((resp) => {
      if (resp.status === 200) {
        commit('UPDATE_ROUTE_GROUP', resp.data)
      }
    })
  },
  async removeRouteGroup({ commit }, routeGroup) {
    await axios.delete(`/sms/route-groups/${routeGroup.id}`).then((resp) => {
      if (resp.status === 204) {
        commit('REMOVE_ROUTE_GROUP', routeGroup)
      }
    })
  },
  async defaultInterRouteGroup({ commit, dispatch }, payload) {
    // Handle if current default route group is not set
    if ([0, 1].includes(payload.default)) {
      let notification = {
        id: Date.now(),
        message: 'Failed to set default route group',
        type: 'error',
        title: 'Route Group',
      }
      dispatch('notification/addNotification', notification, {
        root: true,
      })
      return false
    }
    await axios
      .patch(`/sms/route-groups/default-international`, payload)
      .then((resp) => {
        if (resp.status === 200) {
          commit('DEFAULT_ROUTE_GROUP', resp.data)
        }
      })
  },
  async defaultLocalRouteGroup({ commit, dispatch }, payload) {
    // Handle if current default route group is not set

    if ([0, 1].includes(payload.default)) {
      let notification = {
        id: Date.now(),
        message: 'Failed to set default route group',
        type: 'error',
        title: 'Route Group',
      }
      dispatch('notification/addNotification', notification, {
        root: true,
      })
      return false
    }

    await axios
      .patch(`/sms/route-groups/default-local`, payload)
      .then((resp) => {
        if (resp.status === 200) {
          commit('DEFAULT_ROUTE_GROUP', resp.data)
        }
      })
  },
}
